import { Typography } from "@mui/material"
import { CreateComponent } from "components/utils/CreateComponent"
import React from "react"
import { rootStore } from "store/RootStore"
import { l10n } from "store/lang/L10n"

// MTVW-181 ok
import '../recordingList.css'

const styles = theme => ({})  //MTVW-181  needed for CreateComponent
export const RecordingsSpaceInfo = CreateComponent(styles, false, true, ({ refreshReq }) => {
	// MTVW-1095: replace former Traxis implementation
	/*
	const Customer = rootStore.page.Recordings.oRecCustomer
	console.debug("Customer=", Customer)
	*/
	//console.debug("RecordingsSpaceInfo", refreshReq)
	const [info, setInfo] = React.useState(null)

	React.useEffect(() => {
		rootStore.loginService.getContractInfo().then((res) => {
			//console.debug("contractInfo", res)
			setInfo(res)
		})

		return () => {
		}
	}, [refreshReq])

	// MTVW-1095: replace former Traxis implementation
	/*
	const timeHoursAvailablePercentage = parseInt((Customer?.NpvrQuotaRemainingInMinutes * 100) / Customer?.NpvrQuotaInMinutes)
	const timeHoursUsedPercentage = 100 - timeHoursAvailablePercentage
	const remainingHours =l10n.featureRecordingsRemainingHours?.format(Customer?.NpvrQuotaRemainingInMinutes, Customer?.NpvrQuotaInMinutes)
	*/
	// Safe BigInt Percentage Calculation
	const hasQuotaData = info && info.recordingQuotaTotal && info.recordingQuotaTotal > 0n
   const timeHoursAvailablePercentage = hasQuotaData
      ? Number((info.recordingQuotaRemaining * 100n) / info.recordingQuotaTotal)
      : 0
	const timeHoursUsedPercentage = 100 - timeHoursAvailablePercentage
	const remainingHours = l10n.featureRecordingsRemainingHours?.format(
		info ? Number(info.recordingQuotaRemaining / 60n) : 0,
		info ? Number(info.recordingQuotaTotal / 60n) : 0
	)
	
	return info && (
		<div className={"recordingsInfoWrapper"}>
			<div className={"lineProgressContainer"}>
				<div className={"lineTotHoursUsed"} style={{ width: `${timeHoursUsedPercentage}%` }}></div>
			</div>
			{//Customer?.NpvrQuota !== void 0 && (
				info?.recordingQuotaTotal && (
				<Typography variant="h6" align="center" data-test="recording_space_info_all">
					{remainingHours}		
				</Typography>
			)}
		</div>
	)
})
